import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
  Button,
  Input,
  Checkbox,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/product/closeIconBlack.svg";
import {
  InputControl,
  InputDatePicker,
  SelectControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import useDebounce from "../../../hooks/useDebounce";
import { useConditionalLists } from "../../../hooks/useCustomer";
import SearchBox from "../searchBox";
import SearchCheckBox from "../searchCheckBox";
import { DataPlaceOfIdentification } from "../../../utils/globalVariable";
import { provinceCall } from "../../../api/province";
import { districtCall } from "../../../api/district";
import { wardCall } from "../../../api/ward";
import { commonCall } from "../../../api/common";
import toast from "react-hot-toast";
import imageIcon from "../../../assets/images/booking/image.svg";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const schema = Yup.object().shape({
  name: Yup.string().required("Vui lòng nhập tên khách hàng"),
  phone: Yup.string()
    .transform((value) => (value?.trim() === "" ? null : value))
    .nullable()
    .matches(/^[0-9]+$/, "Số điện thoại không hợp lệ"),
  // .min(10, "Số điện thoại phải có ít nhất 10 chữ số")
  // .max(11, "Số điện thoại không được vượt quá 11 chữ số"),
  // .required("Vui lòng nhập số điện thoại"),
  email: Yup.string().optional().nullable().email("Email không hợp lệ"),
  // .required("Vui lòng nhập email"),
  identificationNumber: Yup.string()
    .transform((value) => (value?.trim() === "" ? null : value))
    .nullable()
    .when("identityNumber", {
      is: 1, // CCCD/CMND
      then: (schema) =>
        schema.matches(
          /^\d{9}$|^\d{12}$/,
          "Số CCCD/CMND không hợp lệ (9 hoặc 12 số)."
        ),
    }),
  // .required("Vui lòng nhập số CCCD/CMND"),
  // dateOfIdentification: Yup.string()
  // .required(
  //   "Vui lòng nhập ngày cấp CCCD/CMND"
  // ),
  // dateOfBirth: Yup.string().required("Vui lòng nhập ngày sinh"),
  // placeOfIdentification: Yup.string().required(
  //   "Vui lòng nhập nơi cấp CCCD/CMND"
  // ),
  // permanentAddress: Yup.string().required("Vui lòng nhập địa chỉ thường trú"),
  // permanentAddressProvince: Yup.string().required(
  //   "Vui lòng nhập tỉnh/thành phố thường trú"
  // ),
  // permanentAddressDistrict: Yup.string().required(
  //   "Vui lòng nhập quận/huyện thường trú"
  // ),
  // permanentAddressWard: Yup.string().required(
  //   "Vui lòng nhập xã/phường thường trú"
  // ),
  // currentAddress: Yup.string().required("Vui lòng nhập địa chỉ hiện tại"),
  // currentAddressProvince: Yup.string().required(
  //   "Vui lòng nhập tỉnh/thành phố hiện tại"
  // ),
  // currentAddressDistrict: Yup.string().required(
  //   "Vui lòng nhập quận/huyện hiện tại"
  // ),
  // currentAddressWard: Yup.string().required("Vui lòng nhập xã/phường hiện tại"),
  // employeeId: Yup.string().required("Vui lòng chọn nhân viên tạo"),
  // customerTypeId: Yup.string().required("Vui lòng nhóm khách hàng"),
  // wishlist: Yup.array()
  //   .transform((value, originalValue) =>
  //     typeof originalValue === "string" && originalValue.trim() === ""
  //       ? []
  //       : value
  //   )
  //   .min(1, "Vui lòng chọn ít nhất một dự án quan tâm")
  //   .required("Vui lòng dự án quan tâm"),
  // // jobId: Yup.string().required("Vui lòng chọn nghề nghiệp"),
  // // customerTypeId: Yup.string().required("Vui lòng chọn phân loại"),
  // // wishlist: Yup.string().required("Vui lòng chọn dự án"),
  // bankName: Yup.string().required("Vui lòng nhập tên ngân hàng"),
  // nameAccount: Yup.string().required("Vui lòng nhập tên tài khoản"),
  // bankAccount: Yup.string().matches(
  //   /^[0-9]+$/,
  //   "Số tài khoản ngân hàng không hợp lệ"
  // ),
  // gender: Yup.number()
  //   .transform((value, originalValue) =>
  //     originalValue === "" ||
  //     originalValue === null ||
  //     originalValue === undefined
  //       ? undefined
  //       : Number(originalValue)
  //   )
  //   .typeError("Giới tính là bắt buộc")
  //   .oneOf([1, 2, 3], "Giới tính không hợp lệ")
  //   .required("Giới tính là bắt buộc"),
  // idCardFrontImage: Yup.string().required("Ảnh CCCD mặt trước là bắt buộc"),
  vnidImage: Yup.string().required("Ảnh VNID là bắt buộc"),
});

const FormNew = ({
  isOpen,
  onClose,
  defaultValues,
  onSubmit,
  isEdit = false,
}) => {
  const {
    register,
    getValues,
    handleSubmit,
    setValue,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {
      identityNumber: 1,
    },
  });
  // console.log(defaultValues);
  const [inputColors, setInputColors] = useState({
    dateOfIdentification: "var(--color-text-unclick)",
  });
  const [focusStates, setFocusStates] = useState({});
  const [permanentAddressProvince, setPermanentAddressProvince] =
    useState(null);
  const [permanentAddressDistrict, setPermanentAddressDistrict] =
    useState(null);
  const [permanentAddressWard, setPermanentAddressWard] = useState(null);
  const [currentAddressProvince, setCurrentAddressProvince] = useState(null);
  const [currentAddressDistrict, setCurrentAddressDistrict] = useState(null);
  const [currentAddressWard, setCurrentAddressWard] = useState(null);

  const watchPermanentAddressProvince = watch("permanentAddressProvince");
  const watchPermanentAddressDistrict = watch("permanentAddressDistrict");
  const watchCurrentAddressProvince = watch("currentAddressProvince");
  const watchCurrentAddressDistrict = watch("currentAddressDistrict");

  const [isLoadingUpload, setIsloadingUpload] = useState(false);
  const [idCardFrontImage, setIdCardFrontImage] = useState(null);
  const [idCardBackImage, setIdCardBackImage] = useState(null);
  const [vnidImage, setVnidImage] = useState(null);
  const [autoFillCheckBox, setAutoFillCheckBox] = useState(false);

  const watchIdentityNumber = watch("identityNumber");

  const genders = [
    {
      value: 1,
      label: "Nam",
    },
    {
      value: 2,
      label: "Nữ",
    },
    {
      value: 3,
      label: "Khác",
    },
  ];

  const identityNumbers = [
    {
      value: 1,
      label: "Số CCCD/CMND",
    },
    {
      value: 2,
      label: "Số hộ chiếu",
    },
  ];

  useEffect(() => {
    if (isOpen) {
      reset(defaultValues);
      setInputColors({
        dateOfIdentification: "var(--text-gray-form)",
      });
    }

    if (!isEdit) {
      setValue("jobId", "");
      setValue("customerTypeId", "");
      setValue("wishlist", "");
      setValue("bankAccount", "");
      setValue("bankName", "");
      setValue("nameAccount", "");
    }

    if (defaultValues?.permanentAddressProvince) {
      setValue(
        "permanentAddressProvince",
        defaultValues?.permanentAddressProvince.toString()
      );
    }

    if (defaultValues?.permanentAddressDistrict) {
      setValue(
        "permanentAddressDistrict",
        defaultValues?.permanentAddressDistrict.toString()
      );
    }

    if (defaultValues?.permanentAddressWard) {
      setValue(
        "permanentAddressWard",
        defaultValues?.permanentAddressWard.toString()
      );
    }

    if (defaultValues?.currentAddressProvince) {
      setValue(
        "currentAddressProvince",
        defaultValues?.currentAddressProvince.toString()
      );
    }

    if (defaultValues?.currentAddressDistrict) {
      setValue(
        "currentAddressDistrict",
        defaultValues?.currentAddressDistrict.toString()
      );
    }

    if (defaultValues?.currentAddressWard) {
      setValue(
        "currentAddressWard",
        defaultValues?.currentAddressWard.toString()
      );
    }

    if (defaultValues?.idCardFrontImage) {
      setIdCardFrontImage((prev) => ({
        ...prev,
        path: defaultValues?.idCardFrontImage,
        id: 1,
        status: true,
        init: true,
      }));
    }

    if (defaultValues?.idCardBackImage) {
      setIdCardBackImage((prev) => ({
        ...prev,
        path: defaultValues?.idCardBackImage,
        id: 2,
        status: true,
        init: true,
      }));
    }

    if (defaultValues?.vnidImage) {
      setVnidImage((prev) => ({
        ...prev,
        path: defaultValues?.vnidImage,
        id: 2,
        status: true,
        init: true,
      }));
    }

    if (
      isEdit &&
      defaultValues?.id &&
      defaultValues?.permanentAddressProvince ===
        defaultValues?.currentAddressProvince &&
      defaultValues?.permanentAddressDistrict ===
        defaultValues?.currentAddressDistrict &&
      defaultValues?.permanentAddressWard ===
        defaultValues?.currentAddressWard &&
      defaultValues?.permanentAddress === defaultValues?.currentAddress
    ) {
      setAutoFillCheckBox(true);
    } else {
      setAutoFillCheckBox(false);
    }

    if (
      !isEdit &&
      defaultValues?.id &&
      defaultValues?.permanentAddressProvince ===
        defaultValues?.currentAddressProvince &&
      defaultValues?.permanentAddressWard ===
        defaultValues?.currentAddressWard &&
      defaultValues?.permanentAddress === defaultValues?.currentAddress
    ) {
      setAutoFillCheckBox(true);
    } else {
      setAutoFillCheckBox(false);
    }
  }, [isOpen, defaultValues, reset]);

  const formatEntriesForSelectProvince = (entries) =>
    Array.isArray(entries)
      ? entries.map(({ code, name }) => ({
          value: code,
          label: name,
        }))
      : Object.entries(entries || {}).map(([code, name]) => ({
          value: code,
          label: name,
        }));

  // tìm tỉnh ban đầu
  useEffect(() => {
    const getProvince = async () => {
      const param = {
        search: "",
      };

      if (defaultValues?.isNewDivision || !isEdit) {
        param.isNew = 1;
      }
      const data = await provinceCall.list(param);

      // console.log(data);
      if (data.items) {
        const options = formatEntriesForSelectProvince(data.items);
        setPermanentAddressProvince(options);
        setCurrentAddressProvince(options);
      }
    };
    getProvince();
  }, []);

  // tìm huyện xã phường Địa chỉ thường trú
  useEffect(() => {
    if (watchPermanentAddressDistrict) {
      const getWard = async () => {
        const data = await wardCall.list({
          search: "",
          district_code: watchPermanentAddressDistrict,
        });
        if (data.items) {
          const options = formatEntriesForSelectProvince(data.items);
          setPermanentAddressWard(options);
        }
      };
      getWard();
    }
  }, [watchPermanentAddressDistrict]);

  useEffect(() => {
    if (watchPermanentAddressProvince) {
      if (isEdit && !defaultValues?.isNewDivision) {
        const getDistrict = async () => {
          const data = await districtCall.list({
            search: "",
            province_code: watchPermanentAddressProvince,
          });
          if (data.items) {
            const options = formatEntriesForSelectProvince(data.items);
            setPermanentAddressDistrict(options);
          }
        };
        getDistrict();
      } else {
        const getWard = async () => {
          const data = await wardCall.listNew({
            search: "",
            province_code: watchPermanentAddressProvince,
          });
          if (data.items) {
            const options = formatEntriesForSelectProvince(data.items);
            setPermanentAddressWard(options);
          }
        };
        getWard();
      }
    }
  }, [watchPermanentAddressProvince]);

  // tìm huyện xã phường Chỗ ở hiện tại
  useEffect(() => {
    if (watchCurrentAddressProvince) {
      if (isEdit && !defaultValues?.isNewDivision) {
        const getDistrict = async () => {
          const data = await districtCall.list({
            search: "",
            province_code: watchCurrentAddressProvince,
          });
          if (data.items) {
            const options = formatEntriesForSelectProvince(data.items);
            setCurrentAddressDistrict(options);
          }
        };
        getDistrict();
      } else {
        const getWard = async () => {
          const data = await wardCall.listNew({
            search: "",
            province_code: watchCurrentAddressProvince,
          });
          if (data.items) {
            const options = formatEntriesForSelectProvince(data.items);
            setCurrentAddressWard(options);
          }
        };
        getWard();
      }
    }
  }, [watchCurrentAddressProvince]);

  useEffect(() => {
    if (watchCurrentAddressDistrict) {
      const getWard = async () => {
        const data = await wardCall.list({
          search: "",
          district_code: watchCurrentAddressDistrict,
        });
        if (data.items) {
          const options = formatEntriesForSelectProvince(data.items);
          setCurrentAddressWard(options);
        }
      };
      getWard();
    }
  }, [watchCurrentAddressDistrict]);

  //set Địa điểm hiện tại giống địa chỉ thường trú
  useEffect(() => {
    if (autoFillCheckBox) {
      setValue("currentAddressProvince", getValues("permanentAddressProvince"));
      setValue("currentAddressWard", getValues("permanentAddressWard"));
      setValue("currentAddress", getValues("permanentAddress"));

      if (isEdit && !defaultValues?.isNewDivision) {
        setValue(
          "currentAddressDistrict",
          getValues("permanentAddressDistrict")
        );
      }
    }
  }, [autoFillCheckBox]);

  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const handleDateChange = (selectedDate, inputName) => {
    setValue(inputName, selectedDate, { shouldValidate: true });
    // const selectedDate = e.target.value;
    // setInputColors((prevColors) => ({
    //   ...prevColors,
    //   [inputName]: selectedDate
    //     ? "var(--color-info-employee)"
    //     : "var(--color-text-unclick)",
    // }));
  };

  const onchangeCareer = (option) => {
    setValue("jobId", option);
  };

  const onchangeType = (option) => {
    setValue("customerTypeId", option);
  };

  const onchangeProject = (option) => {
    setValue("wishlist", option);
  };

  const onchangeEmpoyeeList = (option) => {
    setValue("employeeId", option);
  };

  const onchangeGender = (option) => {
    setValue("gender", option);
  };

  const onchangeIdentityNumber = (option) => {
    setValue("identityNumber", option);
  };

  const submitHandler = (data) => {
    onSubmit(data);
    // console.log(data);
  };

  const [searchTermJob, setSearchTermJob] = useState("");
  const debouncedSearchTermJob = useDebounce(searchTermJob, 500);

  const [searchTermCustomerType, setSearchTermCustomerType] = useState("");
  const debouncedSearchTermCustomerType = useDebounce(
    searchTermCustomerType,
    500
  );

  const [searchTermProject, setSearchTermProject] = useState("");
  const debouncedSearchTermProject = useDebounce(searchTermProject, 500);

  const { jobList, isLoading: jobIsLoading } = useConditionalLists(
    debouncedSearchTermJob,
    { job: true }
  );
  const { customerTypeList, isLoading: customerTypeIsLoading } =
    useConditionalLists(debouncedSearchTermCustomerType, {
      customerType: true,
    });
  const { projectList, isLoading: projectIsLoading } = useConditionalLists(
    debouncedSearchTermProject,
    { project: true }
  );
  const { employeeList } = useConditionalLists(debouncedSearchTermJob, {
    employee: true,
  });

  const formatEntriesForSelect = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  const jobs = useMemo(() => {
    if (!jobList) return [];
    return formatEntriesForSelect(jobList);
  }, [jobList]);
  const customerTypes = useMemo(() => {
    if (!customerTypeList) return [];
    return formatEntriesForSelect(customerTypeList);
  }, [customerTypeList]);
  const projects = useMemo(() => {
    if (!projectList) return [];
    return formatEntriesForSelect(projectList);
  }, [projectList]);
  const employees = useMemo(
    () => formatEntriesForSelect(employeeList),
    [employeeList]
  );

  const initJob = jobs?.find((type) => type.value === watch("jobId"));
  const initType = customerTypes?.find(
    (job) => job.value === watch("customerTypeId")
  );
  const initProject = customerTypes?.filter(
    (job) => job.value === watch("wishlist")
  );

  const onchangePermanentAddressProvince = (option) => {
    // clearErrors("saleBlockId");
    setValue("permanentAddressProvince", option);
    setValue("permanentAddressWard", "");
    setPermanentAddressDistrict(null);
    setPermanentAddressWard(null);
    if (isEdit && !defaultValues?.isNewDivision) {
      setValue("permanentAddressDistrict", "");
    }

    if (autoFillCheckBox) {
      setValue("currentAddressProvince", getValues("permanentAddressProvince"));
      setValue("currentAddressWard", getValues("permanentAddressWard"));
      if (isEdit && !defaultValues?.isNewDivision) {
        setValue(
          "currentAddressDistrict",
          getValues("permanentAddressDistrict")
        );
      }
    }
  };

  const onchangePermanentAddressDistrict = (option) => {
    // clearErrors("saleBlockId");
    setValue("permanentAddressDistrict", option);
    setValue("permanentAddressWard", "");
    setPermanentAddressWard(null);

    if (autoFillCheckBox) {
      setValue("currentAddressDistrict", getValues("permanentAddressDistrict"));
      setValue("currentAddressWard", getValues("permanentAddressWard"));
    }
  };

  const onchangePermanentAddressWard = (option) => {
    // clearErrors("saleBlockId");
    setValue("permanentAddressWard", option);
    if (autoFillCheckBox) {
      setValue("currentAddressWard", getValues("permanentAddressWard"));
    }
  };

  const onchangeCurrentAddressProvince = (option) => {
    // clearErrors("saleBlockId");
    setValue("currentAddressProvince", option);
    setValue("currentAddressDistrict", "");
    setValue("currentAddressWard", "");
    setCurrentAddressDistrict(null);
    setCurrentAddressWard(null);
  };

  const onchangeCurrentAddressDistrict = (option) => {
    // clearErrors("saleBlockId");
    setValue("currentAddressDistrict", option);
    setValue("currentAddressWard", "");
    setCurrentAddressWard(null);
  };

  const onchangeCurrentAddressWard = (option) => {
    // clearErrors("saleBlockId");
    setValue("currentAddressWard", option);
  };

  const uploadIdCardFrontImage = async (file) => {
    setIsloadingUpload(true);
    try {
      if (file) {
        const { filePath } = await commonCall.uploadFile(file, "customerImage");

        if (filePath) {
          setIdCardFrontImage({
            path: filePath,
            id: Date.now(),
            status: true,
            init: false,
          });
          clearErrors("idCardFrontImage");
          setValue("idCardFrontImage", filePath);
          toast.success("Upload ảnh thành công");
        } else {
          toast.error("Có lỗi xảy ra khi upload ảnh");
        }
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast, bấm Tải lại để thử lại
      console.error(error);
    } finally {
      setIsloadingUpload(false);
    }
  };

  const changeIdCardFrontImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setIdCardFrontImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("idCardFrontImage");
        // Chọn ảnh là tự upload, không cần bấm nút
        uploadIdCardFrontImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const uploadIdCardBackImage = async (file) => {
    setIsloadingUpload(true);
    try {
      if (file) {
        const { filePath } = await commonCall.uploadFile(file, "customerImage");

        if (filePath) {
          setIdCardBackImage({
            path: filePath,
            id: Date.now(),
            status: true,
            init: false,
          });
          clearErrors("idCardBackImage");
          setValue("idCardBackImage", filePath);
          toast.success("Upload ảnh thành công");
        } else {
          toast.error("Có lỗi xảy ra khi upload ảnh");
        }
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast, bấm Tải lại để thử lại
      console.error(error);
    } finally {
      setIsloadingUpload(false);
    }
  };

  const changeIdCardBackImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setIdCardBackImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("idCardBackImage");
        // Chọn ảnh là tự upload, không cần bấm nút
        uploadIdCardBackImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const uploadVnidImage = async (file) => {
    setIsloadingUpload(true);
    try {
      if (file) {
        const { filePath } = await commonCall.uploadFile(file, "customerImage");

        if (filePath) {
          setVnidImage({
            path: filePath,
            id: Date.now(),
            status: true,
            init: false,
          });
          clearErrors("vnidImage");
          setValue("vnidImage", filePath);
          toast.success("Upload ảnh thành công");
        } else {
          toast.error("Có lỗi xảy ra khi upload ảnh");
        }
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast, bấm Tải lại để thử lại
      console.error(error);
    } finally {
      setIsloadingUpload(false);
    }
  };

  const changeVnidImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setVnidImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("vnidImage");
        // Chọn ảnh là tự upload, không cần bấm nút
        uploadVnidImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        w={"100%"}
        maxW={"625px"}
        overflowY={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
          "&::-moz-scrollbar": {
            width: "4px",
          },
          "&::-moz-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
        }}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Flex minH={"625px"} flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                {isEdit ? "Chỉnh sửa khách hàng" : "Khách hàng mới"}
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIconBlack} />
              </Box>
            </Flex>
            <Box flex={1} w={"545px"} m={"24px auto"}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Tên khách hàng"
                  placeholder="Nhập tên khách hàng"
                  onFocus={() => handleFocus("name")}
                  onBlur={() => handleBlur("name")}
                  state={focusStates["name"]}
                  register={register("name")}
                  errors={errors.name}
                  isRequired={true}
                  isUppercase={true}
                />
                <InputDatePicker
                  label={"Ngày sinh"}
                  focusStates={focusStates["dateOfBirth"]}
                  selected={watch("dateOfBirth")}
                  onFocus={() => handleFocus("dateOfBirth")}
                  onBlur={() => handleBlur("dateOfBirth")}
                  onChange={(date) => handleDateChange(date, "dateOfBirth")}
                  dateFormat="dd/MM/yyyy"
                  locale="vi"
                  placeholderText="dd/mm/yy"
                  errors={errors?.dateOfBirth}
                  formControlStyle={{
                    maxW: "259px",
                  }}
                  formLabelStyle={{
                    fontWeight: 400,
                    lineHeight: "15px",
                    fontSize: "12px",
                    mb: "6px",
                  }}
                  zIndex={4}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type={"number"}
                  label="Số điện thoại"
                  placeholder="Nhập số điện thoại"
                  register={register("phone")}
                  errors={errors.phone}
                  onFocus={() => handleFocus("phone")}
                  onBlur={() => handleBlur("phone")}
                  state={focusStates["phone"]}
                  // isRequired={true}
                />
                <InputControl
                  type={"email"}
                  label="Email"
                  placeholder="Nhập email"
                  errors={errors.email}
                  onFocus={() => handleFocus("email")}
                  onBlur={() => handleBlur("email")}
                  register={register("email")}
                  state={focusStates["email"]}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label="Giới tính"
                  dataOption={genders}
                  selectedMain={watch("gender")}
                  placeholder="Chọn giới tính"
                  onChange={onchangeGender}
                  onFocus={() => handleFocus("gender")}
                  onBlur={() => handleBlur("gender")}
                  state={focusStates["gender"]}
                  registerProps={register("gender")}
                  errorMessage={errors.gender}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label="Loại giấy tờ tuỳ thân"
                  dataOption={identityNumbers}
                  selectedMain={watch("identityNumber")}
                  placeholder="Chọn loại giấy tờ tuỳ thân"
                  onChange={onchangeIdentityNumber}
                  onFocus={() => handleFocus("identityNumber")}
                  onBlur={() => handleBlur("identityNumber")}
                  state={focusStates["identityNumber"]}
                  registerProps={register("identityNumber")}
                  errorMessage={errors.identityNumber}
                  // isRequired={true}
                />
                <InputControl
                  type={watchIdentityNumber === 1 ? "number" : "text"}
                  label={
                    watchIdentityNumber === 1 ? "Số CCCD/CMND" : "Số hộ chiếu"
                  }
                  placeholder={
                    watchIdentityNumber === 1
                      ? "Nhập số CCCD/CMND"
                      : "Nhập số hộ chiếu"
                  }
                  errors={errors.identificationNumber}
                  onFocus={() => handleFocus("identificationNumber")}
                  onBlur={() => handleBlur("identificationNumber")}
                  register={register("identificationNumber")}
                  state={focusStates["identificationNumber"]}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputDatePicker
                  label={"Ngày cấp"}
                  focusStates={focusStates["dateOfIdentification"]}
                  selected={watch("dateOfIdentification")}
                  onFocus={() => handleFocus("dateOfIdentification")}
                  onBlur={() => handleBlur("dateOfIdentification")}
                  onChange={(date) =>
                    handleDateChange(date, "dateOfIdentification")
                  }
                  dateFormat="dd/MM/yyyy"
                  locale="vi"
                  placeholderText="dd/mm/yy"
                  errors={errors?.dateOfIdentification}
                  formControlStyle={{
                    maxW: "259px",
                  }}
                  formLabelStyle={{
                    fontWeight: 400,
                    lineHeight: "15px",
                    fontSize: "12px",
                    mb: "6px",
                  }}
                  zIndex={3}
                  // isRequired={true}
                />
                <InputControl
                  label="Nơi cấp"
                  placeholder="Nhập nơi cấp"
                  errors={errors.placeOfIdentification}
                  onFocus={() => handleFocus("placeOfIdentification")}
                  onBlur={() => handleBlur("placeOfIdentification")}
                  register={register("placeOfIdentification")}
                  onChange={(e) =>
                    setValue("placeOfIdentification", e.target.value)
                  }
                  data={DataPlaceOfIdentification}
                  state={focusStates["placeOfIdentification"]}
                  // isRequired={true}
                  mwidth={"100%"}
                />
              </Flex>

              {/* Ảnh CCCD mặt trước  */}
              <Box flex={1} mt={"24px"}>
                <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh CCCD mặt trước
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"100%"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {idCardFrontImage && (
                            <Image
                              src={
                                idCardFrontImage?.imageUrl
                                  ? idCardFrontImage?.imageUrl
                                  : `${baseURL}/${idCardFrontImage?.path}`
                              }
                              objectFit={"contain"}
                              h={"100%"}
                              w={"100%"}
                            />
                          )}
                        </Box>
                        {(idCardFrontImage?.path ||
                          idCardFrontImage?.imageUrl) && (
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            top={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              position="absolute"
                              top="8px"
                              right="8px"
                              zIndex={2}
                            >
                              <Button
                                size="sm"
                                colorScheme="red"
                                onClick={() => {
                                  setIdCardFrontImage(null);
                                  setValue("idCardFrontImage", null);
                                }}
                                padding={2}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </Flex>
                        )}

                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeIdCardFrontImage(
                                  e,
                                  1,
                                  idCardFrontImage?.id
                                )
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                      {errors?.idCardFrontImage && (
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                          mt={"8px"}
                        >
                          {errors.idCardFrontImage.message}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {idCardFrontImage?.file && (
                    <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                      <Button
                        bg={"var(--linear-gradient-employee)"}
                        color={"var(--color-main)"}
                        fontSize={"12px"}
                        lineHeight={"17px"}
                        // p={"6px 27px 5px 28px"}
                        fontWeight={"600"}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                        onClick={() =>
                          uploadIdCardFrontImage(idCardFrontImage?.file)
                        }
                        h={"28px"}
                        minH={"28px"}
                        w={"90px"}
                        isLoading={isLoadingUpload}
                      >
                        Tải lại
                      </Button>
                    </Flex>
                  )}
                </Box>
              </Box>

              {/* Ảnh CCCD mặt sau  */}
              <Box flex={1} mt={"24px"} mb={"24px"}>
                <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh CCCD mặt sau
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"100%"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {idCardBackImage && (
                            <Image
                              src={
                                idCardBackImage?.imageUrl
                                  ? idCardBackImage?.imageUrl
                                  : `${baseURL}/${idCardBackImage?.path}`
                              }
                              objectFit={"contain"}
                              h={"100%"}
                              w={"100%"}
                            />
                          )}
                        </Box>
                        {(idCardBackImage?.path ||
                          idCardBackImage?.imageUrl) && (
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            top={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              position="absolute"
                              top="8px"
                              right="8px"
                              zIndex={2}
                            >
                              <Button
                                size="sm"
                                colorScheme="red"
                                onClick={() => {
                                  setIdCardBackImage(null);
                                  setValue("idCardBackImage", null);
                                }}
                                padding={2}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </Flex>
                        )}

                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeIdCardBackImage(e, 2, idCardBackImage?.id)
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                      {errors?.idCardBackImage && (
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                          mt={"8px"}
                        >
                          {errors.idCardBackImage.message}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {idCardBackImage?.file && (
                    <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                      <Button
                        bg={"var(--linear-gradient-employee)"}
                        color={"var(--color-main)"}
                        fontSize={"12px"}
                        lineHeight={"17px"}
                        // p={"6px 27px 5px 28px"}
                        fontWeight={"600"}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                        onClick={() =>
                          uploadIdCardBackImage(idCardBackImage?.file)
                        }
                        h={"28px"}
                        minH={"28px"}
                        w={"90px"}
                        isLoading={isLoadingUpload}
                      >
                        Tải lại
                      </Button>
                    </Flex>
                  )}
                </Box>
              </Box>

              {/* Ảnh VNID  */}
              <Box flex={1} mt={"24px"} mb={"24px"}>
                <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh VNID
                        </Text>
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text>
                      </Flex>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"100%"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {vnidImage && (
                            <Image
                              src={
                                vnidImage?.imageUrl
                                  ? vnidImage?.imageUrl
                                  : `${baseURL}/${vnidImage?.path}`
                              }
                              objectFit={"contain"}
                              h={"100%"}
                              w={"100%"}
                            />
                          )}
                        </Box>
                        {(vnidImage?.path || vnidImage?.imageUrl) && (
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            top={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              position="absolute"
                              top="8px"
                              right="8px"
                              zIndex={2}
                            >
                              <Button
                                size="sm"
                                colorScheme="red"
                                onClick={() => {
                                  setVnidImage(null);
                                  setValue("vnidImage", null);
                                }}
                                padding={2}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </Flex>
                        )}

                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeVnidImage(e, 2, vnidImage?.id)
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                      {errors?.vnidImage && (
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                          mt={"8px"}
                        >
                          {errors.vnidImage.message}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {vnidImage?.file && (
                    <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                      <Button
                        bg={"var(--linear-gradient-employee)"}
                        color={"var(--color-main)"}
                        fontSize={"12px"}
                        lineHeight={"17px"}
                        // p={"6px 27px 5px 28px"}
                        fontWeight={"600"}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                        onClick={() => uploadVnidImage(vnidImage?.file)}
                        h={"28px"}
                        minH={"28px"}
                        w={"90px"}
                        isLoading={isLoadingUpload}
                      >
                        Tải lại
                      </Button>
                    </Flex>
                  )}
                </Box>
              </Box>

              {/* Địa chỉ thưởng trú */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label="Chọn tỉnh địa chỉ thường trú"
                  dataOption={permanentAddressProvince}
                  selectedMain={watch("permanentAddressProvince")}
                  placeholder="Chọn tỉnh địa chỉ thường trú"
                  isSearchable={true}
                  onChange={onchangePermanentAddressProvince}
                  onFocus={() => handleFocus("permanentAddressProvince")}
                  onBlur={() => handleBlur("permanentAddressProvince")}
                  state={focusStates["permanentAddressProvince"]}
                  errorMessage={errors.permanentAddressProvince}
                  registerProps={register("permanentAddressProvince")}
                  // isRequired={true}
                />
                {isEdit && !defaultValues?.isNewDivision ? (
                  <SelectControl
                    label="Chọn huyện địa chỉ thường trú"
                    dataOption={permanentAddressDistrict}
                    selectedMain={watch("permanentAddressDistrict")}
                    placeholder="Chọn huyện"
                    isSearchable={true}
                    onChange={onchangePermanentAddressDistrict}
                    onFocus={() => handleFocus("permanentAddressDistrict")}
                    onBlur={() => handleBlur("permanentAddressDistrict")}
                    state={focusStates["permanentAddressDistrict"]}
                    errorMessage={errors.permanentAddressDistrict}
                    registerProps={register("permanentAddressDistrict")}
                    // isRequired={true}
                  />
                ) : (
                  <SelectControl
                    label="Chọn phường, xã địa chỉ thường trú"
                    dataOption={permanentAddressWard}
                    selectedMain={watch("permanentAddressWard")}
                    placeholder="Chọn phường, xã"
                    isSearchable={true}
                    onChange={onchangePermanentAddressWard}
                    onFocus={() => handleFocus("permanentAddressWard")}
                    onBlur={() => handleBlur("permanentAddressWard")}
                    state={focusStates["permanentAddressWard"]}
                    errorMessage={errors.permanentAddressWard}
                    registerProps={register("permanentAddressWard")}
                    // isRequired={true}
                  />
                )}
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                {isEdit && !defaultValues?.isNewDivision ? (
                  <SelectControl
                    label="Chọn phường, xã địa chỉ thường trú"
                    dataOption={permanentAddressWard}
                    selectedMain={watch("permanentAddressWard")}
                    placeholder="Chọn phường, xã"
                    isSearchable={true}
                    onChange={onchangePermanentAddressWard}
                    onFocus={() => handleFocus("permanentAddressWard")}
                    onBlur={() => handleBlur("permanentAddressWard")}
                    state={focusStates["permanentAddressWard"]}
                    errorMessage={errors.permanentAddressWard}
                    registerProps={register("permanentAddressWard")}
                    // isRequired={true}
                  />
                ) : (
                  ""
                )}
                <Box w={"100%"}>
                  <InputControl
                    label="Chi tiết địa chỉ thường trú"
                    placeholder="Nhập địa chỉ thường trú"
                    errors={errors.permanentAddress}
                    onFocus={() => handleFocus("permanentAddress")}
                    onBlur={() => handleBlur("permanentAddress")}
                    register={register("permanentAddress")}
                    state={focusStates["permanentAddress"]}
                    mwidth={"100%"}
                    // isRequired={true}
                    onChangeData={() => {
                      if (autoFillCheckBox) {
                        setValue(
                          "currentAddress",
                          getValues("permanentAddress")
                        );
                      }
                    }}
                  />
                  <Text
                    lineHeight={"15px"}
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    mt={{ base: "4px" }}
                    color={"var(--color-option-employee-hover)"}
                  >
                    ( Chỉ ghi địa chỉ cụ thể, không ghi phường/xã, huyện/quận,
                    tỉnh )
                  </Text>
                </Box>
              </Flex>

              {/* Check box auto fill */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <Checkbox
                  alignItems={"center"}
                  onChange={() => {
                    setAutoFillCheckBox(!autoFillCheckBox);
                  }}
                  isChecked={autoFillCheckBox}
                >
                  <Text
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    lineHeight={"15px"}
                    color={"var(--color-black-label)"}
                  >
                    Địa điểm hiện tại giống địa chỉ thường trú
                  </Text>
                </Checkbox>
              </Flex>

              {/* Chọn chỗ ở hiện tại  */}
              {!autoFillCheckBox && (
                <>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"16px"}
                  >
                    <SelectControl
                      label="Chọn tỉnh chỗ ở hiện tại"
                      dataOption={currentAddressProvince}
                      selectedMain={watch("currentAddressProvince")}
                      placeholder="Chọn tỉnh"
                      isSearchable={true}
                      onChange={onchangeCurrentAddressProvince}
                      onFocus={() => handleFocus("currentAddressProvince")}
                      onBlur={() => handleBlur("currentAddressProvince")}
                      state={focusStates["currentAddressProvince"]}
                      errorMessage={errors.currentAddressProvince}
                      registerProps={register("currentAddressProvince")}
                      // isRequired={true}
                    />
                    {isEdit && !defaultValues?.isNewDivision ? (
                      <SelectControl
                        label="Chọn Huyện chỗ ở hiện tại"
                        dataOption={currentAddressDistrict}
                        selectedMain={watch("currentAddressDistrict")}
                        placeholder="Chọn huyện"
                        isSearchable={true}
                        onChange={onchangeCurrentAddressDistrict}
                        onFocus={() => handleFocus("currentAddressDistrict")}
                        onBlur={() => handleBlur("currentAddressDistrict")}
                        state={focusStates["currentAddressDistrict"]}
                        errorMessage={errors.currentAddressDistrict}
                        registerProps={register("currentAddressDistrict")}
                        // isRequired={true}
                      />
                    ) : (
                      <SelectControl
                        label="Chọn phường, xã chỗ ở hiện tại"
                        dataOption={currentAddressWard}
                        selectedMain={watch("currentAddressWard")}
                        placeholder="Chọn phường, xã"
                        isSearchable={true}
                        onChange={onchangeCurrentAddressWard}
                        onFocus={() => handleFocus("currentAddressWard")}
                        onBlur={() => handleBlur("currentAddressWard")}
                        state={focusStates["currentAddressWard"]}
                        errorMessage={errors.currentAddressWard}
                        registerProps={register("currentAddressWard")}
                        // isRequired={true}
                      />
                    )}
                  </Flex>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"16px"}
                  >
                    {isEdit && !defaultValues?.isNewDivision ? (
                      <SelectControl
                        label="Chọn phường, xã chỗ ở hiện tại"
                        dataOption={currentAddressWard}
                        selectedMain={watch("currentAddressWard")}
                        placeholder="Chọn phường, xã"
                        isSearchable={true}
                        onChange={onchangeCurrentAddressWard}
                        onFocus={() => handleFocus("currentAddressWard")}
                        onBlur={() => handleBlur("currentAddressWard")}
                        state={focusStates["currentAddressWard"]}
                        errorMessage={errors.currentAddressWard}
                        registerProps={register("currentAddressWard")}
                        // isRequired={true}
                      />
                    ) : (
                      ""
                    )}

                    <Box w={"100%"}>
                      <InputControl
                        label="Chi tiết chỗ ở hiện tại"
                        placeholder="Nhập chỗ ở hiện tại"
                        errors={errors.currentAddress}
                        onFocus={() => handleFocus("currentAddress")}
                        onBlur={() => handleBlur("currentAddress")}
                        state={focusStates["currentAddress"]}
                        register={register("currentAddress")}
                        mwidth={"100%"}
                        // isRequired={true}
                      />
                      <Text
                        lineHeight={"15px"}
                        fontSize={{ base: "12px" }}
                        fontWeight={400}
                        mt={{ base: "4px" }}
                        color={"var(--color-option-employee-hover)"}
                      >
                        ( Chỉ ghi địa chỉ cụ thể, không ghi phường/xã,
                        huyện/quận, tỉnh )
                      </Text>
                    </Box>
                  </Flex>
                </>
              )}

              {/* Kết thúc chọn chỗ ở hiện tại  */}

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SearchBox
                  label={"Nghề nghiệp"}
                  isSearchable={true}
                  placeholder="Chọn nghề nghiệp"
                  selectedMain={watch("jobId")}
                  initialSelectedEmp={initJob}
                  onChange={onchangeCareer}
                  data={jobs}
                  isLoading={jobIsLoading}
                  searchTerm={searchTermJob}
                  setSearchTerm={setSearchTermJob}
                  errorMessage={errors.jobId}
                  onFocus={() => handleFocus("jobId")}
                  onBlur={() => handleBlur("jobId")}
                  state={focusStates["jobId"]}
                />

                <SearchBox
                  label={"Nhóm khách hàng"}
                  isSearchable={true}
                  placeholder="Chọn nhóm khách hàng"
                  selectedMain={watch("customerTypeId")}
                  initialSelectedEmp={initType}
                  onChange={onchangeType}
                  data={customerTypes}
                  isLoading={customerTypeIsLoading}
                  searchTerm={searchTermCustomerType}
                  setSearchTerm={setSearchTermCustomerType}
                  errorMessage={errors.customerTypeId}
                  onFocus={() => handleFocus("customerTypeId")}
                  onBlur={() => handleBlur("customerTypeId")}
                  state={focusStates["customerTypeId"]}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SearchCheckBox
                  label={"Dự án quan tâm"}
                  isSearchable={true}
                  placeholder="Chọn dự án quan tâm"
                  selectedMain={watch("wishlist")}
                  initialSelectedEmp={initProject}
                  onChange={onchangeProject}
                  data={projects}
                  isLoading={projectIsLoading}
                  searchTerm={searchTermProject}
                  setSearchTerm={setSearchTermProject}
                  errorMessage={errors.wishlist}
                  // isRequired={true}
                />
                <InputControl
                  type="number"
                  label="Số tài khoản"
                  placeholder="Nhập số tài khoản"
                  errors={errors.bankAccount}
                  onFocus={() => handleFocus("bankAccount")}
                  onBlur={() => handleBlur("bankAccount")}
                  state={focusStates["bankAccount"]}
                  register={register("bankAccount")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Tên ngân hàng"
                  placeholder="Nhập tên ngân hàng"
                  errors={errors.bankName}
                  onFocus={() => handleFocus("bankName")}
                  onBlur={() => handleBlur("bankName")}
                  state={focusStates["bankName"]}
                  register={register("bankName")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
                <InputControl
                  label="Chủ tài khoản ngân hàng"
                  placeholder="Nhập chủ tài khoản"
                  errors={errors.nameAccount}
                  onFocus={() => handleFocus("nameAccount")}
                  onBlur={() => handleBlur("nameAccount")}
                  state={focusStates["nameAccount"]}
                  register={register("nameAccount")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label={"Nhân viên tạo"}
                  dataOption={employees}
                  placeholder="Chọn nhân viên"
                  selectedMain={watch("employeeId")}
                  onChange={onchangeEmpoyeeList}
                  onFocus={() => handleFocus("employeeId")}
                  onBlur={() => handleBlur("employeeId")}
                  state={focusStates["employeeId"]}
                  registerProps={register("employeeId")}
                  errorMessage={errors.employeeId}
                  mwidth="100%"
                  isSearchable={true}
                  // isRequired={true}
                />
              </Flex>
            </Box>
            <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
              {isEdit ? (
                <>
                  <Button
                    onClick={onClose}
                    w={"112px"}
                    h={"44px"}
                    color={"var(--color-option-employee-hover)"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    _hover={{
                      filter: "brightness(80%)",
                    }}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    h={"44px"}
                    color={"var(--color-main)"}
                    bg={"var(--color-button)"}
                    _hover={{
                      filter: "brightness(80%)",
                    }}
                  >
                    Lưu
                  </Button>
                </>
              ) : (
                <Button
                  type="submit"
                  w={"164px"}
                  h={"44px"}
                  color={"var(--color-main)"}
                  bg={"var(--color-button)"}
                  _hover={{
                    filter: "brightness(80%)",
                  }}
                >
                  Tạo khách hàng
                </Button>
              )}
            </Flex>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default FormNew;
